module.exports = __webpack_public_path__ + "img/face-0.83f3f36d.jpg";